<template>
  <i-modal
    :title="$t(edit ? 'editing' : 'add', { value: $tc('date', 1) })"
    :value="value"
    :load="loading"
    @submit="submit"
    @input="$emit('input', $event)"
  >
    <v-row class="my-0">
      <v-col cols="12" sm="6">
        <dialtype
          ref="dialtype"
          @done="addTypeDate"
          v-model="dialog2"
          :template="template"
          :to-edit="toEdit2"
        />
        <v-skeleton-loader
          v-if="load"
          type="list-item-avatar"
          tile
        ></v-skeleton-loader>
        <ValidationProvider
          vid="type"
          :name="$tc('type', 1)"
          rules="required"
          v-slot="{ errors }"
        >
          <v-autocomplete
            v-model="date.type"
            name="typecontact"
            autocomplete="off"
            :error-messages="errors[0]"
            :items="types"
            :loading="isLoading"
            :clearable="types.length > 10"
            outlined
            class="secondary--text"
            item-text="name"
            item-value="pk"
            key="type-input"
            :append-icon="types.length > 10 ? 'fa-search' : ''"
            :label="$t('typedate')"
            :prepend-inner-icon="
              getPermissions([`sales.add_typedate`]) || isAdmin ? 'fa-plus' : ''
            "
            @click:prepend-inner="open()"
          ></v-autocomplete>
        </ValidationProvider>
      </v-col>
      <v-col cols="12" sm="6">
        <i-date-picker
          color="primary"
          :loading="loading"
          :label="$tc('date', 1)"
          v-model="date.date"
        />
      </v-col>
      <v-col cols="12">
        <v-textarea
          class="secondary--text"
          outlined
          :label="$tc('observation', 1)"
          v-model="date.observation"
        ></v-textarea>
      </v-col>
    </v-row>
  </i-modal>
</template>
<script>
import { mapGetters } from 'vuex'
import dialtype from '../typeDate/modal.vue'

export default {
  props: {
    template: {
      type: Number
    },
    order: {
      required: true,
      type: Number
    },
    value: {
      type: Boolean,
      default: false
    },
    toEdit: {
      type: [Object],
      default: () => null
    }
  },
  components: {
    dialtype
  },
  data() {
    return {
      date: {
        suborder: this.order,
        type: null,
        observation: '',
        date: '',
        changeDate: false
      },
      dialog: false,
      load: false,
      menu: false,
      types: [],
      loading: false,
      isLoading: false,
      edit: false,
      valid: false,
      dialog2: false,
      reload2: false,
      toEdit2: null
    }
  },
  computed: {
    ...mapGetters({
      getPermissions: 'session/getPermissions',
      company: 'company/getCompanyData',
      isAdmin: 'session/isAdmin'
    }),
    datemain: {
      set(newValue) {
        if (this.date.date.length > newValue.length) {
          this.date.date = null
        }
      },
      get() {
        return this.dateFormat(this.date.date)
      }
    }
  },
  methods: {
    open(item) {
      this.toEdit2 = item === undefined ? null : item
      this.dialog2 = true
    },
    addTypeDate(evt) {
      this.types.push(evt)
      this.date.type = evt.pk
    },
    async getTypeDate() {
      this.isLoading = true
      try {
        if (this.template > 0) {
          let response = await this.$api.dashboard.typedate.list({
            opt: {
              params: {
                template: this.template,
                company: this.company.pk
              }
            }
          })
          this.types = response.data.results
            .filter((item) => item.promise === false)
            .sort((a, b) => {
              const nameA = a.template
              const nameB = b.template
              if (nameA === null) {
                return 1
              }
              if (nameB === null) {
                return -1
              }
              return 0
            })
        } else {
          this.$toast.error('este producto no tiene plantilla')
        }
      } finally {
        this.isLoading = false
      }
    },
    async submit() {
      if (!this.loading) {
        try {
          this.loading = true
          const date = !this.edit
            ? await this.$api.suborder.date.create({ form: this.date })
            : await this.$api.suborder.date.edit({
                pk: this.date.pk,
                form: this.date
              })
          this.$emit('done', date.data)
          this.$emit('input', false)
          this.$toast.success(
            `${this.$tc('terms', 1)} ${this.$tc(
              this.edit ? 'edited' : 'created',
              1
            )}`
          )
        } finally {
          this.loading = false
        }
      }
    }
  },
  watch: {
    template: {
      immediate: true,
      handler(val) {
        if (typeof val === 'number') {
          this.getTypeDate()
        }
      }
    },
    value: {
      immediate: true,
      handler(val) {
        if (val) {
          this.getTypeDate()
          this.edit = this.toEdit !== null
          this.date =
            this.toEdit !== null
              ? { ...this.toEdit }
              : {
                  suborder: this.order,
                  type: null,
                  observation: '',
                  date: '',
                  changeDate: false
                }
        }
      }
    }
  }
}
</script>
